interface radioOption {
  id: string;
  value: string | number;
  label: string;
}

interface Props {
  name: string;
  label: string;
  selectedValue: string | number;
  setSelectedValue: (value: any) => void;
  radioOptions: radioOption[];
}

export default function RadioButton({
  name,
  label,
  selectedValue,
  setSelectedValue,
  radioOptions,
}: Props) {
  return (
    <div
      className='d-flex flex-column'
      key={name}
    >
      <label className='dropdown-label'>{label}</label>
      <div className='d-flex gap-3'>
        {radioOptions.map((option) => {
          return (
            <div
              className='d-flex gap-2'
              key={option.id}
            >
              <input
                type='radio'
                name={name}
                value={option.value}
                checked={selectedValue === option.value}
                onChange={() => setSelectedValue(option.value)}
              />
              <label htmlFor={option.id}>{option.label}</label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
